import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/tim-viec-lam/client.tsx");
